import { Box, useTheme } from "@mui/material";
import type { ReactNode } from "react";

export type FormItemRowProps = {
    children: ReactNode;
    density?: "compact" | "comfortable";
    testId?: string;
};

/** Shared bordered surface for filled repeatable entity form rows. */
export const FormItemRow = ({ children, density = "compact", testId }: FormItemRowProps) => {
    const theme = useTheme();

    return (
        <Box
            data-testid={testId}
            sx={{
                alignItems: "center",
                backgroundColor: theme.custom.grey[200],
                borderRadius: theme.spacing(1.5),
                boxSizing: "border-box",
                display: "flex",
                flexWrap: "wrap",
                gap: theme.spacing(2),
                padding: theme.spacing(density === "comfortable" ? 2 : 1.5),
                position: "relative",
                width: "100%",
            }}
        >
            {children}
            <Box
                aria-hidden="true"
                sx={{
                    borderColor: theme.custom.strokes.containerDivider.color,
                    borderRadius: "inherit",
                    borderStyle: theme.custom.strokes.containerDivider.style,
                    borderWidth: theme.custom.strokes.containerDivider.width,
                    boxSizing: "border-box",
                    inset: 0,
                    pointerEvents: "none",
                    position: "absolute",
                }}
            />
        </Box>
    );
};
